export { default as Navbar } from './Navbar/Navbar';
export { default as Footer } from './Footer/Footer';
export { default as TestimonialsCarousel } from './TestimonialsCarousel/TestimonialsCarousel';
export { default as PerspectiveText } from './PerspectiveText/PerspectiveText';
